"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileOpen, setMobileOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted-light-background animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted-light-background animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted-light-background animate-pulse rounded-md" />
      </div>;
  }
  const uniqueMenuItems = menuItems.filter((item, index, self) => index === self.findIndex(t => t.label === item.label));
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {uniqueMenuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative px-4 py-2 text-black font-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:text-primary-dark group">
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu">
        {mobileOpen ? <X className="size-5" /> : <Menu className="size-5" />}
      </Button>

      {}
      {mobileOpen && <div className="absolute top-full left-0 w-full bg-light-background shadow-medium rounded-b-lg md:hidden z-50">
          <nav className="flex flex-col p-4 space-y-2">
            {uniqueMenuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="px-4 py-2 text-black font-medium rounded-md hover:bg-muted-light-background transition-all duration-[var(--duration-fast)]" onClick={() => setMobileOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 z-50 w-full transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${scrolled ? "h-[calc(var(--space-xl)*2.8)] shadow-medium" : "h-[calc(var(--space-xl)*4)]"} bg-light-background rounded-b-lg`}>
      <div className="container mx-auto h-full px-4 flex items-center justify-between">
        {}
        <Link to="/" className="flex-shrink-0 transition-transform duration-[var(--duration-medium)] hover:scale-105">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1474184/img/texas_margaritas_logo.png" alt="Texas Margaritas Mexican Restaurant" className="h-7" />
        </Link>

        {}
        <MenuProvider menu_id="17" className="flex-1 flex justify-center">
          <HeaderMenuConsumer />
        </MenuProvider>

        {}
        <Button asChild className="hidden md:inline-flex bg-primary-dark text-foreground-primary hover:bg-primary-dark hover:scale-[1.02] transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] shadow-soft rounded-md">
          <Link to="/ContactPage">Make Reservation</Link>
        </Button>
      </div>
    </header>;
}